import React from "react";

export const styleForVariant = (
  variant,
  isOpenForApplications
) => {

  if (
    variant === "red" &&
    !isOpenForApplications
  ) {
    return {
      backgroundColor: "#FEE2E2",
      border: "1px solid #FCA5A5",
    };
  }

  return {};
};

export const badgeForVariant = (
  variant,
  tooltip
) => {

  if (!variant) return null;

  const base = {
    position: "absolute",
    right: 6,
    bottom: 6,
    width: 16,
    height: 16,
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 10,
    fontWeight: 700,
    lineHeight: 1,
    cursor: "help",
    border: "1px solid rgba(0,0,0,0.08)",
    boxShadow:
      "0 1px 2px rgba(0,0,0,0.06)",

    zIndex: 2,
    pointerEvents: "auto",
  };

  return (
    <span
      title={tooltip}
      onClick={(e) =>
        e.stopPropagation()
      }

      style={{
        ...base,
        backgroundColor: "#FCA5A5",
        color: "#7F1D1D",
      }}
    >
      ❗
    </span>
  );
};

export const applicationBadge = (
  isOpen
) => {

  if (!isOpen) return null;

  return (
    <span
      title="Öppet för ansökningar"

      style={{
        position: "absolute",
        top: 6,
        right: 6,

        padding: "2px 6px",

        borderRadius: 6,

        fontSize: 10,
        fontWeight: 700,

        backgroundColor: "#DCFCE7",
        color: "#166534",

        border:
          "1px solid #86EFAC",

        zIndex: 2,
      }}
    >
      Öppet pass
    </span>
  );
};

export const buildTooltip = (
  missing,
  variant
) => {

  const reason =
    variant === "red"
      ? "Saknar anställd"
      : ["project", "start", "end"]

          .filter((k) => missing[k])

          .map((k) =>
            k === "project"
              ? "Saknar projekt"
              : k === "start"
              ? "Saknar starttid"
              : "Saknar sluttid"
          )

          .join(", ");

  return `
    Ofullständigt skift:
    ${reason}.
    Ej synligt för anställda
    och ingår inte i timmar/lön
    räkningen.
  `;
};